import { createSelector } from 'reselect';

import { AppState } from '../../../../../store/models/app-state';

const supplierSpecialOffersListState = (state: AppState) => state.contentManagement.supplierSpecialOffers.list;

export const supplierSpecialOffersListItemsSelector = createSelector(
    supplierSpecialOffersListState,
    state => state.items
);
export const supplierSpecialOffersListRequestingSelector = createSelector(
    supplierSpecialOffersListState,
    state => state.requesting
);
